export default "__VITE_ASSET__Bn_adPb5__"